import { render, staticRenderFns } from "./CartAdditionsFailed.vue?vue&type=template&id=40c989bb&"
import script from "./CartAdditionsFailed.vue?vue&type=script&lang=js&"
export * from "./CartAdditionsFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports